import moment from 'moment'

interface LuxPlusCardExpiry {
  expMonth?: number
  expYear?: number
}

function getLuxPlusCardExpiresBeforeRenewal(card?: LuxPlusCardExpiry, renewalDate?: string | Date): boolean {
  if (!renewalDate || !card?.expYear || !card.expMonth) return false

  return moment({
    year: card.expYear,
    month: card.expMonth - 1,
  }).endOf('month').isBefore(moment(renewalDate))
}

export default getLuxPlusCardExpiresBeforeRenewal
